import { useGenerateWisdomResponse } from '@modules/oracle/hooks';
import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function usePostPromptIfSearchParamExists() {
  const [searchParams] = useSearchParams();
  const promptInput = searchParams.get('prompt');
  const [isAPIRequestPending, setIsAPIRequestPending] = useState(!!promptInput);
  const sessionID = useOracleSearchStore(({ data }) => data.sessionID);
  const [generateWisdomResponse, { isLoading }] = useGenerateWisdomResponse({});

  const dependencies = { generateWisdomResponse };
  const dependenciesRef = useRef(dependencies);
  dependenciesRef.current = dependencies;

  useEffect(() => {
    if (!!promptInput && sessionID) {
      setIsAPIRequestPending(false);

      dependenciesRef.current.generateWisdomResponse({
        question: promptInput,
        onGenerate: () => {},
      });
    }
  }, [promptInput, sessionID]);

  return isAPIRequestPending || isLoading;
}
